import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD = 'add'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT = 'edit'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_ADD = {
  Button: Button.Outlined,
  key: ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  props: {
    beforeIconProps: { Icon: PlusIcon },
    height: BUTTON_HEIGHT_32,
    tooltip: 'Profile.AddInfoItemBtnTooltipKey',
  },
  show: contentExist => !contentExist,
}

export const ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_EDIT = {
  Button: Button.Outlined,
  key: ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
  props: {
    beforeIconProps: { Icon: EditIcon },
    height: BUTTON_HEIGHT_32,
    tooltip: 'Profile.EditInfoItemBtnTooltipKey',
  },
  show: contentExist => contentExist,
}

export const ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_DEFAULT = [
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_EDIT,
]
